import { LockedBlurredListOverlay } from '../shared/LockedPlanPieces'
import { IdealCategoryList } from './IdealCategoryList'
import { IDEAL_BLURRED_CATEGORIES } from '../../../../../mock/data/blurFixtures'

/** PLAN_ROLLED_OUT but not Prime. */
export function IdealBlurredBody() {
  return (
    <LockedBlurredListOverlay
      message={
        <>
          Your ideal portfolio is
          <br />
          currently locked
        </>
      }
      buttonLabel="Unlock with Prime"
      landingPage="prime"
    >
      <IdealCategoryList categories={IDEAL_BLURRED_CATEGORIES} />
    </LockedBlurredListOverlay>
  )
}
